import React from "react";
import { ConnectedProps, connect } from "react-redux";
import Avatar from "@material-ui/core/Avatar";
import { makeStyles, Typography } from "@material-ui/core";
import { ApplicationState } from "../store";
import { actions, Coverage } from "../store/Insurance";
import { Theme } from "../.themes";

const avatarStyles = makeStyles((theme: Theme) => ({
  ComponentWrapper: {
    display: "inline-flex",
    flexWrap: "wrap",
    gap: 16,
    marginBottom: "11px",
  },
  PersonaAvatar: {
    width: 54,
    height: 54,
    border: `2px solid ${theme.colorCard?.primary || theme.palette.primary.main}`,
  },
  AvatarSubtitle: {
    color: theme.palette.grey[600],
    fontSize: "0.875rem",
  },
  ContentWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  title: {
    fontWeight: 700,
    ...theme?.avatar?.title,
  },
}));

const PersonaAvatar: React.FC<AvatarProps> = (props: AvatarProps) => {
  const classes = avatarStyles();

  const selectedPreText = `${props.currentCoverage?.IsRecommended ? props.recommendedTitle : "Du har valt"} `;
  const singleRecommendText = `${selectedPreText} ${props.currentCoverage?.LongName}`;

  return (
    <>
      {props.persona && props.persona.subtitle && (
        <div className={classes.ComponentWrapper}>
          <Avatar className={classes.PersonaAvatar} src={props.persona.imageUrl} />
          <div className={classes.ContentWrapper}>
            <Typography variant='subtitle2' className={classes.title}>
              {singleRecommendText}
            </Typography>
            <Typography className={classes.AvatarSubtitle}>{props.persona.subtitle}</Typography>
          </div>
        </div>
      )}
    </>
  );
};

const connector = connect(
  (state: ApplicationState) => ({
    persona: state.texts?.persona,
  }),
  {
    onChange: actions.insuranceCoverageChanged,
  },
);

type AvatarProps = ConnectedProps<typeof connector> & {
  recommendedTitle?: string;
  currentCoverage?: Coverage;
};

export default connector(PersonaAvatar);
